import React from "react";
import DownloadAppStore from "../Assets/download-app-store.png";
import GetItOn from "../Assets/get-it-on.png";
import { APP_STORE_URL, PLAY_STORE_URL } from "../storeLinks";

const Work = () => {
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        {/* <p className="primary-subheading">Work</p> */}
        <h1 className="primary-heading">Soldi app for Apple & Android</h1>
        <p className="primary-text">
        Improve your personal finance management with Soldi, and simplify your financial tracking.  
        {/* Easily input your expenses and categorize them for effortless monitoring. Utilize analysis tools to gain insights into your spending habits and set personalized budgets, receiving timely alerts to help you stay on track with your financial goals. */}
        </p>
        <div className="about-buttons-container">
          <a 
            href={APP_STORE_URL} 
            className="store-button"
            rel="noopener noreferrer"
          >
            <img src={DownloadAppStore} alt="Download on the App Store" />
          </a>
          <a 
            href={PLAY_STORE_URL} 
            className="store-button"
            rel="noopener noreferrer"
          >
            <img src={GetItOn} alt="Get it on Google Play" />
          </a>
          {/* <button className="secondary-button">Download for Android</button> */}
          {/* <button className="watch-video-button">
            <BsFillPlayCircleFill /> Download for Android
          </button> */}
        </div>
        <div className="work-section-image-container">
        {/* <img src={QrDownload} alt="" /> */}
      </div>

      </div>
      {/* <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt="" />
            </div>
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default Work;
